import { Component, effect, Inject, inject, LOCALE_ID } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { idUploadRoute, manualOrgKeyRoute, scanQrRoute } from 'src/app/route-names';
import { ElectorDataService, IdvStatus } from 'src/app/Services/elector-data.service';
import { ScreenOrderService } from 'src/app/Services/screen-order.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { VotedEventRecord, Ballot } from 'src/app/ballot/backend-types';
import { DecisionDialogService, DialogType } from 'src/app/Services/decision-dialog.service';
import { ApiAboutService } from 'src/app/Services/api-about.service';
import { CustomerOidProfileSnapshot } from 'src/app/backend-types/misc-types';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-verification-panel',
    imports: [MatIconModule, MatExpansionModule, MatProgressSpinnerModule],
    templateUrl: './verification-panel.component.html',
    styleUrl: './verification-panel.component.scss'
})
export class VerificationPanelComponent {
  router = inject(Router)
  isAddOrganizationNeeded = false
  dialogTitle?: string;
  dialogText?: string;
  idvStatus: IdvStatus = 'NONE';
  idvStatusDate: string | undefined;
  statusText = ''
  displaySpinner = false
  constructor(
    private dialog: MatDialog,
    readonly screenService: ScreenOrderService,
    public electorDataService: ElectorDataService,
    private decisionDialogService: DecisionDialogService,
    private readonly about: ApiAboutService,
    @Inject(LOCALE_ID) readonly locale: string
  ) {
    effect(() => {
      this.idvStatus = this.electorDataService.idvStatus()
      this.idvStatusDate = this.electorDataService.idvTimestamp()
      if (this.idvStatusDate === undefined || this.idvStatusDate === '') {
        this.statusText = $localize`ID Verification Status: ${this.idvStatus}.`;
      } else {
        this.statusText = $localize`ID Verification Status: ${this.idvStatus}. Last update: ${this.dateReadable(this.idvStatusDate)}.`;
      }
    });
  }

  dateReadable(date: string): string {
    return new Date(date).toLocaleString(this.locale,
      {
        weekday: "long", month: "long", day: "numeric", year: "numeric",
        hour: "numeric", minute: "numeric", second: "numeric"
      });
  }

  gotoIdentity(){
    if(this.about.VWAFlowType === 'GLOBAL') {
      const dialogRef = this.decisionDialogService.openDialog(
        DialogType.CONFIRM,
        $localize`Confirm ID Verification`,
        $localize`Does your jurisdiction or organization require ID verification?`,
      );
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.router.navigate(idUploadRoute);
        }
      });
    } else {
      this.router.navigate(idUploadRoute);
    }
  }
  
  scanQR() {
   this.router.navigate(scanQrRoute)
  }
  
  orgKeyManual(){
    this.router.navigate(manualOrgKeyRoute)
  }

  hideVerification(): boolean {
    return (['FAILED', 'PENDING', 'SUCCESS'].includes(this.idvStatus));
  }
}

export interface IdvStatusWithEvents {
  idv_status: IdvStatus;
  idv_status_timestamp?: string;
  events?: Ballot[];
  votedEvents?: VotedEventRecord[];
  orgVerifications?: CustomerOidProfileSnapshot[];
  dashboardUpdateLockTimeSeconds?: number;
}